import { init as initApm } from '@elastic/apm-rum';
import config from '../config';

const apm = initApm({
  serviceName: 'tripvibes',
  serverUrl: `https://events.${config.media.host}`,
  serviceVersion: '0.0.1',
  environment: import.meta.env.VITE_APP_ENV || 'production',
  instrument: true,
  breakdownMetrics: true,
  centralConfig: false,
  disableInstrumentations: ['click', 'eventtarget'],
});

const shouldGroup = (url?: string): boolean => {
  if (!url) {
    return false;
  }
  if (url.includes('media.tripvibes.app')) {
    return false;
  }
  if (url.includes('tripvibes.app/api/')) {
    return false;
  }
  return true;
};

const groupUrls = (urlOrPath: string, fullUrl?: boolean): string => {
  try {
    const path = urlOrPath.startsWith('http') ? new URL(urlOrPath).pathname : urlOrPath;

    const segments = path.split('/').filter(Boolean);
    const newPath = segments.length > 0 ? `/${segments[0]}` : '/';
    if (fullUrl) {
      return `https://tripvibes.app` + newPath;
    }
    return newPath;
  } catch (e) {
    return '/unknown';
  }
};

apm.addFilter((payload) => {
  const scrub = (item: any) => {
    if (shouldGroup(item.name)) {
      console.log('name: ' + item.name);
      item.name = groupUrls(item.name);
    }
    if (shouldGroup(item.context?.page?.url)) {
      item.context.page.url = groupUrls(item.context.page.url, true);
    }
    if (item.context?.request) {
      if (shouldGroup(item.context.request.url)) {
        item.context.request.url = groupUrls(item.context.request.url, true);
      }
      item.context.request.referrer = '[REDACTED]';
      const headers = item.context.request.headers || {};
      const ua = headers['user-agent'] || headers['User-Agent'];
      item.context.request.headers = ua ? { 'User-Agent': ua } : {};
      delete item.context.request.cookies;
    }
    if (item.spans) {
      item.spans.forEach((span: any) => {
        if (shouldGroup(span.context?.http?.url)) {
          span.context.http.url = groupUrls(span.context.http.url, true);
        }
        if (shouldGroup(span.name)) {
          span.name = groupUrls(span.name, true);
        }
      });
    }

    console.log(item);
  };
  payload.errors?.forEach(scrub);
  payload.transactions?.forEach(scrub);
  return payload;
});

export default apm;
